import { render, staticRenderFns } from "./AllRecipes.vue?vue&type=template&id=53648b28&"
import script from "./AllRecipes.vue?vue&type=script&lang=js&"
export * from "./AllRecipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports